import { sendAuthRequest } from ".";
import { ClientDataMapper } from "../mappers/clientsMapper";

const CLIENTS_URL = '/api/profile/clients';

export const getClients = async () => {
    const response = await sendAuthRequest(CLIENTS_URL, 'GET');
    return ClientDataMapper.toDomainModel(response);
};